import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.css";
import NaviBarv2 from "./Components/NaviBarv2";
import Footer from "./Components/Footer";
import { Container, Row, Col, Card, Badge, Button, Alert } from "react-bootstrap";

// Базовый URL для скачивания документов (та же схема, что и на странице «Данные»).
// В проде REACT_APP_API_URL='/' → относительный путь; в деве — http://localhost:8001.
const DOCS_BASE =
  (process.env.REACT_APP_API_URL || "http://localhost:8001").replace(/\/$/, "") +
  "/api/documents";
const ACCENT = "#198754";

// Общий раскладочный класс карточки-шаблона: строка на sm+ (текст слева, кнопка справа),
// на xs — столбец с кнопкой во всю ширину (как в оригинальной странице).
const CARD_BODY =
  "d-flex flex-column flex-sm-row justify-content-sm-between align-items-sm-center gap-3";

const numStyle = {
  width: 32,
  height: 32,
  borderRadius: "50%",
  background: ACCENT,
  color: "#fff",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 700,
  fontSize: 14,
  marginBottom: 10,
};

const noteStyle = {
  background: "#e8f3ec",
  color: "#1b5e37",
  borderRadius: 4,
};

// Последовательность действий при регистрации РИД (текст — из оригинальной страницы)
const RID_STEPS = [
  {
    n: 1,
    title: "Заполнение форм",
    text:
      "Заполняются необходимые формы пакета документов. Если регистрируется БД заполнить: Уведомление, Реферат БД, Согласие автора, Согласие на ОПД, Структура БД. Для регистрации программы: Уведомление, Согласие автора, Согласие на ОПД, Код программы, Реферат ПрЭВМ. Заполненные формы направляются по электронной почте на адрес: denisenko.nd@talantiuspeh.ru.",
    note: "При отправке указывайте тему: «Пакет документов РИД — [Название]».",
  },
  {
    n: 2,
    title: "Проверка и выявление",
    text:
      "Срок: 10 рабочих дней. Проверка Уведомления, патентный поиск, учёт в плане работ. При необходимости — рассмотрение на НТК.",
    note: "При ошибках документы возвращаются на доработку.",
  },
  {
    n: 3,
    title: "Согласование в Тессе",
    text:
      "Создаётся СЗ «иное». Получатель: Денисенко Н.Д. 7 согласующих. Прикладываются заполненные, но НЕ подписанные формы.",
    note: "Правки — только в режиме редактирования.",
  },
  {
    n: 4,
    title: "Подписание",
    text:
      "Срок: 5 рабочих дней. Подписание у всех авторов. Скан-копии — в Тессу, оригиналы — в ЦИСПТ.",
    note: "Подписи расшифровываются (ФИО + дата).",
  },
  {
    n: 5,
    title: "Регистрация",
    text:
      "Срок: 1 рабочий день. Внесение в реестр РИД, присвоение номера, сканирование, архив.",
    note: "РИД считается учтённым и защищённым.",
  },
  {
    n: 6,
    title: "Подготовка заявки на РИД",
    text:
      "Срок: 5 рабочих дней. Подготовка пакета для Роспатента. Закрытие СЗ в Тессе. Общий срок ~1 месяц.",
    note: "Заявка — только после внутреннего согласования.",
  },
  {
    n: 7,
    title: "Договор отчуждения (сторонние авторы)",
    text:
      "Срок: 15–30 рабочих дней. Проверка контрагентов, подписание ГПХ на отчуждение прав.",
    note: "Без договора права не переходят к Университету.",
  },
];

// Шаблоны документов пакета РИД. file — ASCII-имя на сервере, download — «красивое» имя при скачивании.
const RID_TEMPLATES = [
  {
    icon: "📄",
    name: "Уведомление о создании РИД",
    desc: "Основной документ — уведомление о создании РИД",
    file: "notice.docx",
    download: "Шаблон Уведомление о создании РИД.docx",
    fmt: "Word (.docx / .doc)",
  },
  {
    icon: "📝",
    name: "Реферат БД",
    desc: "Реферат базы данных — аннотация, ОС, СУБД, объём",
    file: "abstract-bd.docx",
    download: "Шаблон Реферат БД.docx",
    fmt: "Word (.docx / .doc)",
  },
  {
    icon: "📊",
    name: "Структура БД",
    desc: "Структура базы данных — введение, описание, литература",
    file: "structure-bd.docx",
    download: "Шаблон Структура БД.docx",
    fmt: "Word (.docx / .doc)",
  },
  {
    icon: "🔐",
    name: "Согласие на ОПД",
    desc: "Согласие на обработку персональных данных — для каждого автора",
    file: "pd-consent.doc",
    download: "Согласие на ОПД ЭВМ БД.doc",
    fmt: "Word (.docx / .doc)",
  },
  {
    icon: "✍️",
    name: "Согласие автора на указание сведений",
    desc: "Согласие автора на указание сведений об авторе в заявлении",
    file: "author-consent.doc",
    download: "Согласие автора на указание сведений об авторе.doc",
    fmt: "Word (.docx / .doc)",
  },
  {
    icon: "💻",
    name: "Код программы для ПрЭВМ",
    desc: "Фрагмент исходного текста программы для ЭВМ",
    file: "program-code.doc",
    download: "Шаблон Код программы для ПрЭВМ.doc",
    fmt: "Word (.docx / .doc)",
  },
  {
    icon: "⚙️",
    name: "Реферат ПрЭВМ",
    desc: "Реферат программы для ЭВМ — назначение, функции, ОС, язык",
    file: "abstract-program.docx",
    download: "Шаблон Реферат ПрЭВМ.docx",
    fmt: "Word (.docx / .doc)",
  },
  {
    icon: "📽️",
    name: "Оформление РИД (БД) — пример",
    desc: "Презентация с примером оформления пакета документов для БД",
    file: "rid-formatting-guide.pptx",
    download: "Оформление РИД БД.pptx",
    fmt: "PowerPoint (.pptx)",
  },
];

function RidRegistration() {
  return (
    <div className="App">
      <NaviBarv2 />

      <Container className="py-4 text-start">
        {/* Заголовок страницы */}
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-2">Регистрация РИД</h1>
          <p className="text-muted mb-2">
            АНОО ВО «Университет «Сириус» — пакет документов для регистрации базы
            данных (БД) и программы для ЭВМ (ПрЭВМ)
          </p>
          <Badge bg="success" className="fs-6 px-3 py-2">
            Пакет документов РИД
          </Badge>
        </div>

        {/* Последовательность действий */}
        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            Последовательность действий при регистрации РИД
          </h2>
          <Row className="g-3">
            {RID_STEPS.map((s) => (
              <Col key={s.n} md={6} lg={4}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body>
                    <div style={numStyle}>{s.n}</div>
                    <h3 className="h6 fw-bold">{s.title}</h3>
                    <p className="text-muted small mb-2">{s.text}</p>
                    <div className="small px-2 py-1" style={noteStyle}>
                      {s.note}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Alert variant="warning" className="mt-3 mb-0">
            <strong>Важно:</strong> Куда отправлять:{" "}
            <strong>denisenko.nd@talantiuspeh.ru</strong>. На согласование —{" "}
            <strong>НЕ подписанные</strong> формы в Word.
          </Alert>
        </section>

        {/* Как работать с шаблонами (выравнивание по левому краю) */}
        <section className="mb-5">
          <Card className="border-0 shadow-sm text-start">
            <Card.Body>
              <h3 className="h5 fw-bold" style={{ color: ACCENT }}>
                📋 Как работать с шаблонами
              </h3>
              <ol className="text-muted mb-3">
                <li>
                  <strong>Скачайте</strong> нужный шаблон Word, нажав на кнопку{" "}
                  <strong>«Скачать»</strong>.
                </li>
                <li>
                  <strong>Откройте</strong> скачанный файл в Microsoft Word.
                </li>
                <li>
                  <strong>Заполните</strong> все поля в соответствии с вашими
                  данными.
                </li>
                <li>
                  <strong>Сохраните</strong> заполненный документ на своём
                  компьютере.
                </li>
                <li>
                  <strong>Отправьте</strong> заполненные формы по электронной
                  почте: <strong>denisenko.nd@talantiuspeh.ru</strong>.
                </li>
              </ol>
              <Alert variant="info" className="mb-0 small">
                <strong>💡 Совет:</strong> Сохраняйте файлы с именем по формату:{" "}
                <em>«Уведомление_РИД_БД_[Название].docx»</em>,{" "}
                <em>«Реферат_ПрЭВМ_[Название].docx»</em> и т.д.
              </Alert>
            </Card.Body>
          </Card>
        </section>

        {/* Шаблоны документов */}
        <section className="mb-5">
          <h2
            className="fw-bold pb-2 mb-4"
            style={{ borderBottom: `2px solid ${ACCENT}` }}
          >
            📄 Шаблоны документов пакета РИД
          </h2>
          <Row className="g-3">
            {RID_TEMPLATES.map((t, i) => (
              <Col key={i} md={6}>
                <Card className="border-0 shadow-sm h-100">
                  <Card.Body className={CARD_BODY}>
                    <div className="text-start">
                      <div className="fw-semibold">
                        {t.icon} {t.name}
                      </div>
                      <div className="text-muted small">{t.desc}</div>
                      <div className="small fw-semibold" style={{ color: ACCENT }}>
                        {t.fmt}
                      </div>
                    </div>
                    <Button
                      variant="success"
                      href={`${DOCS_BASE}/rid/${t.file}`}
                      download={t.download}
                      className="text-nowrap text-center flex-shrink-0"
                    >
                      📥 Скачать
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
          <Alert variant="info" className="mt-3 mb-0 small">
            <strong>ℹ️ Примечание:</strong> Все шаблоны соответствуют утверждённым
            формам АНОО ВО «Университет «Сириус». После заполнения формы должны
            быть подписаны всеми авторами и направлены на согласование.
          </Alert>
        </section>
      </Container>

      <Footer />
    </div>
  );
}

export default RidRegistration;
